import React, { Component } from 'react'

import AlertBanner from 'components/alerts/alert-banner'
import FileDisplay from 'components/file/file-display'
import Icon from 'components/icon/icon'

export default class SingleTaskFiles extends Component {
    openPreviewModal = (files, index) => {
		this.props.openModal('preview', 'files', { 
			files,
			startIndex: index,
			//path: this.props.match.path.replace('/tasks/:task_id', '')
		})
	}
	
	render() {
		const {
			openFile,
			deleteFile,
			filesInReverse,
			currentTab,
			isProjectEditable
		} = this.props

		return (
			<div>
				<ul className="mini-file-grid">
					{
						!filesInReverse.length ?
						<AlertBanner 
							low={true} 
							title={'No files'} 
							body={"Upload a file, or link one from your project's files. "} 
						/>
						: null
					}
					{
						filesInReverse.map((fileObject, i) => {
							return(
								<li key={i} style={{transitionDelay: (i/7)+'s' }}>
									<a onClick={_ => {
										this.openPreviewModal(filesInReverse, i)
									}} target="_blank">
										<FileDisplay 
											file={fileObject.latestVersion} 
										/>
										<div className="controls">
											<span className="file-name">
												{ fileObject.name }
											</span>
											{ isProjectEditable ?
											<div onClick={e => {e.stopPropagation(); e.preventDefault()}}>
												<button onClick={e => {openFile(fileObject.id)}}>
													<Icon name="fe-edit-2" />
													Details 
												</button>
												<button onClick={_ => {deleteFile(fileObject)}}>
													<Icon name="fe-trash-2" />
													Delete
												</button>
											</div>
											: null }
										</div>
									</a>
								</li>
							)
						})
					}
				</ul>
			</div>
		)
	}
}



// WEBPACK FOOTER //
// ./src/sections/projects/project/project-tasks/single-task/single-task-files.jsx